import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
    videoWrapper: {
        position: 'relative',
        width: '100%',
        paddingBottom: '56.25%', // 16:9 aspect ratio (9 / 16 = 0.5625)
        backgroundColor: '#000',
    },
    video: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'contain',
    },
}));

export default function VideoPlayer({ src, autoPlay = false, muted = false, controls = true }) {
    const classes = useStyles();

    return (
        <div className={classes.videoWrapper}>
            <video
                className={classes.video}
                src={src}
                autoPlay={autoPlay}
                muted={muted}
                controls={controls}
            >
                Your browser does not support the video tag.
            </video>
        </div>
    );
}
